import React from 'react'
import withView from '../docAutomation/withView';
import DocLogRow from './DocLogRow';
import FormTitle from '../../../library/form/components/FormTitle'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo } from "../../../library/layout/Index";

const DocLog = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null);

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Comments' />
                    </span>
                </UiTitle>
                <UiAction>
                    <FormButton formObject={formObject} ksc="l" rowKey="" starIcon={"adds"}
                        action={{ actionId: "new",  actionParam: { isint: "0" }, containerKey: "popup" }}
                        className="uiActionIconButton" text={<SarasTrans value="Comment" />}></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColTwo>
                    <ul>
                        {
                            Object.values(viewData).map((row, index) => (
                                <DocLogRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                            ))
                        }
                    </ul>
                </UiGridColTwo>
            </UiViewContent>
        </UiView >
    )
}

export default withView(DocLog, "taskLog", "taskHead,taskDetail")